var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_650_5927)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.833 0.166977C15.9114 0.245246 15.9653 0.344596 15.9882 0.452943C16.0112 0.56129 16.0021 0.673964 15.9622 0.777262L10.2479 15.6344C10.2075 15.7395 10.1368 15.8304 10.0449 15.8955C9.95302 15.9606 9.84391 15.9971 9.73131 16.0004C9.61872 16.0037 9.50766 15.9736 9.4121 15.914C9.31653 15.8544 9.24072 15.7678 9.19419 15.6653L6.80448 10.4081L10.3199 6.89155C10.4713 6.72906 10.5537 6.51415 10.5498 6.29209C10.5459 6.07004 10.4559 5.85817 10.2989 5.70112C10.1419 5.54408 9.92999 5.45412 9.70793 5.45021C9.48587 5.44629 9.27096 5.52871 9.10848 5.68012L5.59191 9.19555L0.334762 6.80698C0.231867 6.76051 0.145044 6.6846 0.0852508 6.58883C0.0254578 6.49306 -0.00462542 6.38172 -0.001202 6.26887C0.00222141 6.15602 0.038998 6.04671 0.104486 5.95474C0.169974 5.86278 0.261239 5.79227 0.366762 5.75212L15.2239 0.0378337C15.3271 -0.00185253 15.4395 -0.0107755 15.5476 0.012146C15.6557 0.0350674 15.7549 0.0888495 15.833 0.166977Z",
    fill: "#573B76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_650_5927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.3ef3303c1b1c1abcde452e6ee4193d03.svg";
export { ForwardRef as ReactComponent };